import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import { getRatio, getModel, SliderMixin, keyCodes } from "./slider-utils.js";
import { between } from "../../utils/format.js";
import { stopAndPrevent } from "../../utils/event.js";
export default Vue.extend({
  name: 'QSlider',
  mixins: [SliderMixin],
  props: {
    value: {
      required: true,
      default: null,
      validator: function validator(v) {
        return typeof v === 'number' || v === null;
      }
    },
    labelValue: [String, Number]
  },
  data: function data() {
    return {
      model: this.value === null ? this.min : this.value,
      curRatio: 0
    };
  },
  watch: {
    value: function value(v) {
      this.model = v === null ? 0 : between(v, this.min, this.max);
    },
    min: function min(v) {
      this.model = between(this.model, v, this.max);
    },
    max: function max(v) {
      this.model = between(this.model, this.min, v);
    }
  },
  computed: {
    ratio: function ratio() {
      return this.active === true ? this.curRatio : this.modelRatio;
    },
    modelRatio: function modelRatio() {
      return this.minMaxDiff === 0 ? 0 : (this.model - this.min) / this.minMaxDiff;
    },
    trackStyle: function trackStyle() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, this.positionProp, 0), _defineProperty(_ref, this.sizeProp, "".concat(100 * this.ratio, "%")), _ref;
    },
    thumbStyle: function thumbStyle() {
      return _defineProperty({}, this.positionProp, "".concat(100 * this.ratio, "%"));
    },
    thumbClass: function thumbClass() {
      if (this.preventFocus === false && this.focus === true) {
        return 'q-slider--focus';
      }
    },
    pinClass: function pinClass() {
      if (this.labelColor !== void 0) {
        return "text-".concat(this.labelColor);
      }
    },
    pinTextClass: function pinTextClass() {
      return 'q-slider__pin-value-marker-text' + (this.labelTextColor !== void 0 ? " text-".concat(this.labelTextColor) : '');
    },
    events: function events() {
      if (this.editable === true) {
        return this.$q.platform.is.mobile === true ? {
          click: this.__mobileClick
        } : {
          mousedown: this.__activate,
          focus: this.__focus,
          blur: this.__blur,
          keydown: this.__keydown,
          keyup: this.__keyup
        };
      }
    },
    computedLabel: function computedLabel() {
      return this.labelValue !== void 0 ? this.labelValue : this.model;
    },
    pinStyle: function pinStyle() {
      var percent = this.reverse === true ? -this.ratio : this.ratio - 1;
      return this.__getPinStyle(percent, this.ratio);
    }
  },
  methods: {
    __updateValue: function __updateValue(change) {
      if (this.model !== this.value) {
        this.$emit('input', this.model);
      }

      change === true && this.$emit('change', this.model);
    },
    __getDragging: function __getDragging() {
      return this.$el.getBoundingClientRect();
    },
    __updatePosition: function __updatePosition(event) {
      var dragging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dragging;
      var ratio = getRatio(event, dragging, this.isReversed, this.vertical);
      this.model = getModel(ratio, this.min, this.max, this.step, this.decimals);
      this.curRatio = this.snap !== true || this.step === 0 ? ratio : this.minMaxDiff === 0 ? 0 : (this.model - this.min) / this.minMaxDiff;
    },
    __focus: function __focus() {
      this.focus = true;
    },
    __keydown: function __keydown(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }

      stopAndPrevent(evt);
      var step = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
          offset = [34, 37, 40].includes(evt.keyCode) ? -step : step;
      this.model = between(parseFloat((this.model + offset).toFixed(this.decimals)), this.min, this.max);

      this.__updateValue();
    }
  },
  render: function render(h) {
    var child = [this.__getThumbSvg(h), h('div', {
      staticClass: 'q-slider__focus-ring'
    })];

    if (this.label === true || this.labelAlways === true) {
      child.push(h('div', {
        staticClass: "q-slider__pin q-slider__pin".concat(this.axis, " absolute"),
        style: this.pinStyle.pin,
        class: this.pinClass
      }, [h('div', {
        staticClass: "q-slider__pin-text-container q-slider__pin-text-container".concat(this.axis),
        style: this.pinStyle.pinTextContainer
      }, [h('span', {
        staticClass: 'q-slider__pin-text',
        class: this.pinTextClass
      }, [this.computedLabel])])]), h('div', {
        staticClass: "q-slider__arrow q-slider__arrow".concat(this.axis),
        class: this.pinClass
      }));
    }

    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(child, 'push');
    }

    var track = [h('div', {
      staticClass: "q-slider__track q-slider__track".concat(this.axis, " absolute"),
      style: this.trackStyle
    })];
    this.markers === true && track.push(h('div', {
      staticClass: "q-slider__track-markers q-slider__track-markers".concat(this.axis, " absolute-full fit"),
      style: this.markerStyle
    }));
    return h('div', {
      staticClass: this.value === null ? ' q-slider--no-value' : '',
      attrs: _objectSpread(_objectSpread({}, this.attrs), {}, {
        'aria-valuenow': this.value,
        tabindex: this.computedTabindex
      }),
      class: this.classes,
      on: this.events,
      directives: this.panDirectives
    }, [h('div', {
      staticClass: "q-slider__track-container q-slider__track-container".concat(this.axis, " absolute")
    }, track), h('div', {
      staticClass: "q-slider__thumb-container q-slider__thumb-container".concat(this.axis, " absolute non-selectable"),
      class: this.thumbClass,
      style: this.thumbStyle
    }, child)]);
  }
});